import { cn } from '@/lib/utils';
import { Info, CheckCircle, AlertTriangle, AlertCircle } from 'lucide-react';

type MessageStyle = 'info' | 'success' | 'warning' | 'important';

interface WelcomeMessageStylePickerProps {
  value: MessageStyle;
  onChange: (value: MessageStyle) => void;
}

const styles: { value: MessageStyle; label: string; Icon: any; colors: { bg: string; border: string; icon: string } }[] = [
  {
    value: 'info',
    label: 'Info',
    Icon: Info,
    colors: {
      bg: 'bg-blue-50',
      border: 'border-blue-300',
      icon: 'text-blue-600',
    },
  },
  {
    value: 'success',
    label: 'Success',
    Icon: CheckCircle,
    colors: {
      bg: 'bg-green-50',
      border: 'border-green-300',
      icon: 'text-green-600',
    },
  },
  {
    value: 'warning',
    label: 'Warning',
    Icon: AlertTriangle,
    colors: {
      bg: 'bg-amber-50',
      border: 'border-amber-300',
      icon: 'text-amber-600',
    },
  },
  {
    value: 'important',
    label: 'Important',
    Icon: AlertCircle,
    colors: {
      bg: 'bg-red-50',
      border: 'border-red-300',
      icon: 'text-red-600',
    },
  },
];

export function WelcomeMessageStylePicker({ value, onChange }: WelcomeMessageStylePickerProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {styles.map((style) => {
        const Icon = style.Icon;
        const isSelected = value === style.value;
        
        return (
          <button
            key={style.value}
            type="button"
            onClick={() => onChange(style.value)}
            className={cn(
              'flex items-center gap-2 p-3 rounded-lg border-2 transition-all',
              style.colors.bg,
              isSelected ? style.colors.border : 'border-transparent',
              'hover:opacity-80'
            )}
          >
            <Icon className={cn('h-5 w-5', style.colors.icon)} />
            <span className={cn('text-sm font-medium', style.colors.icon)}>
              {style.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
